import api from "../utils/axios";
export async function getUserOrders() {
  try {
    const res = await api.get(`/auth/orders`);
    return res.data;
  } catch (error) {
    console.error("Failed to load Orders:", error);
    throw error;
  }
}


export async function getUserOrdersDetail(id) {
  try {
    const res = await api.get(`/auth/orders/${id}`);
    return res.data;
  } catch (error) {
    console.error("Failed to load Orders:", error);
    throw error;
  }
}

// CREATE
export async function createOrder(order) {
  const response = await api.fetch(`/auth/orders`, {
    method: "POST",

    headers: {
      "Content-Type": "application/json",
    },

    body: JSON.stringify(order),
  });

  return response.json();
}
